module.exports = __webpack_public_path__ + "static/img/花瓶5.076b6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶5.png
// module id = EK8Z
// module chunks = 2